module.exports = __webpack_public_path__ + "static/media/gliding_snow.70ca4a84.svg";